import { renderCellGrayZerosRedConditions } from 'app/common/templates-next/table-template'
import { ColumnKey } from './tableColumns'
import { CellLoadingController } from '../cells/CellLoadingController'

type CommonCell<T extends ColumnKey> = T extends ColumnKey.StudentName
  ? {
      columnKey: ColumnKey.StudentName
      lastRow: boolean
      value: string
    }
  : {
      columnKey: T
      value: string
    }

type CellType = CommonCell<ColumnKey> | undefined

export const renderTableCell = (cellData: CellType) => {
  if (cellData?.columnKey === ColumnKey.StudentName) {
    return <CellLoadingController {...cellData} />
  }
  return renderCellGrayZerosRedConditions(cellData)
}
